import { useRef } from "react";
import { images } from "@img/imagesMap";
import { DateUtils } from "@utils/dayUtill";

interface StyledDateInputProps {
  value: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  min?: string;
  disabled?: boolean;
  buttonClassName?: string;
  textClassName?: string;
  // 사이드프로필 입사일 / 근무 종료일 용도
  noHover?: boolean;
}

export default function StyledDateInput({
  value,
  onChange,
  placeholder = "-",
  className = "",
  min,
  disabled = false,
  buttonClassName = "",
  textClassName = "",
  noHover = false,
}: StyledDateInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (inputRef.current && !disabled) {
      try {
        // 브라우저의 네이티브 날짜 선택기를 강제로 실행
        inputRef.current.showPicker();
      } catch (e) {
        // showPicker 미지원 브라우저 대응 (focus로 대체)
        inputRef.current.focus();
      }
    }
  };

  const displayValue = value
    ? DateUtils.dateFormatKR(value, "YYYY-MM-DD")
    : placeholder;

  // 호버 스타일 조건부 적용
  const hoverClass = noHover ? "" : "hover:border-[#939399]";

  return (
    <div className={`relative inline-block ${className}`}>
      {/* 시각적인 Select 박스 트리거 */}
      <button
        type="button"
        disabled={disabled}
        onClick={handleClick}
        className={`text-left font-pretendard border rounded-[5px] h-[30px] px-2 w-[110px] pr-[1.2rem] border-[#D6D6DE] bg-white flex items-center justify-between transition-colors ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : `cursor-pointer ${hoverClass}`
        } ${buttonClassName} `}
      >
        <span
          className={`${textClassName} text-[14px] font-pretendard whitespace-nowrap ${
            value ? "text-[#333333]" : "text-[#999]"
          }`}
        >
          {displayValue}
        </span>
        <img
          src={images.icon_chevron_down_fill_gray}
          alt=""
          aria-hidden="true"
          className="w-[0.8em] h-[0.8em] pointer-events-none flex-shrink-0 ml-1"
        />
      </button>

      {/* 실제 데이터 처리를 위한 숨겨진 input */}
      <input
        ref={inputRef}
        type="date"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        disabled={disabled}
        className="absolute w-0 h-0 opacity-0 pointer-events-none"
        tabIndex={-1}
      />
    </div>
  );
}
